export default {
  props: {
    buttonPopUpConfig: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    getStyle(item) {
      if (item.buttonBgColor == '#fff') {
        return 'color:' + item.buttonFontColor + ';background-color:' + item.buttonBgColor + ';border:1px solid' + item.buttonFontColor + ';border-radius:5px';
      }
      return 'color:' + item.buttonFontColor + ';background-color:' + item.buttonBgColor;
    }
  }
};